import React from "react";
import SearchIcon from "assets/Icon_Form_Search_01.png";
import CrossIcon from "assets/Icon_Form_Search_02.png";
import { ThreeBounce } from "better-react-spinkit";

type Props = JSX.IntrinsicElements["input"] & {
  onSearchStringChange?(searchString: string): void;
  initialSearchString: string;
  goToPage?(page: number): void;
  loading?: boolean;
  loadingSize?: number;
};

const SearchBox: React.FC<Props> = ({
  onSearchStringChange,
  initialSearchString,
  goToPage,
  loading,
  loadingSize,
  ...props
}) => {
  const [search, setSearch] = React.useState(initialSearchString);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (onSearchStringChange) {
      onSearchStringChange(search);
      if (goToPage) {
        goToPage(1);
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const clearSearch = () => {
    setSearch("");
    if (onSearchStringChange) {
      onSearchStringChange("");
      if (goToPage) {
        goToPage(1);
      }
    }
  };

  const isEmpty = search === "";

  return (
    <form onSubmit={handleSubmit} className="SearchBoxContainer">
      <input
        data-testid="ddm-search"
        className="SearchBox"
        placeholder="Type your search here"
        value={search}
        onChange={handleChange}
        {...props}
      />

      {loading && (
        <div className="LoadingContainer">
          <ThreeBounce size={loadingSize ? loadingSize : 6} />
        </div>
      )}

      {isEmpty && !loading && (
        <img src={SearchIcon} alt="Search" className="SearchIcon" onClick={clearSearch} />
      )}

      {!isEmpty && !loading && (
        <img src={CrossIcon} alt="Clear" className="ClearSearchIcon" onClick={clearSearch} />
      )}
    </form>
  );
};

export { SearchBox };
